<template>
  <div class="33355"><slot :apiKey="apiKey" :loading="isloading"></slot></div>
</template>

<script>
import { getCEditorApiKey } from '@/api/common';
import { getOrFetch } from '@/utils/globalCache';
export default {
  data() {
    return {
      apiKey: '',
      isloading: true
    }
  },
  mounted() {
    getOrFetch('EditorApiKey', async () => {
      const res = await getCEditorApiKey({
        appId: 'health-bianque-man',
        namespaceKey: 'editorKey',
        configKey: 'key',
      });
      console.log('# 发起了请求');
      return res.editorKey.key;
    }).then(res => {
      this.apiKey = res;
      this.isloading = false;
    }).catch(e => {
      console.log('get editorKey error');
    });
  }
}
/*
  <EditorWrapper >
    <template v-slot:default="{ apiKey, loading }">
      <editor v-if="!loading" :apiKey="apiKey" />
      <div v-else>加载中...</div>
    </template> 
  </EditorWrapper>
*/
</script>

